import { useState } from 'react';
import { useSafeLayoutEffect } from './use-safe-layout-effect';

type State = {
  width: number;
  height: number;
};

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<State>({
    width: 0,
    height: 0,
  });

  const isMobile = windowSize.width <= 550;
  const isTablet = windowSize.width > 550 && windowSize.width <= 1100;
  const isLaptop = windowSize.width > 1100 && windowSize.width <= 1500;
  const isDesktop = windowSize.width > 1500;

  useSafeLayoutEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { ...windowSize, isMobile, isTablet, isLaptop, isDesktop };
};

export { useWindowSize };
